import {Observable, ReplaySubject} from 'rxjs';
import {take, tap} from 'rxjs/operators';

type CacheKey = string | number;

/**
 * Check if calls to "call" with params "params" are already cached. If so, return cached result, otherwise,
 * perform "call" and cache result.
 */
export function withResultCache<Result>(call: () => Observable<Result>, cache: {[s: CacheKey]: ReplaySubject<Result>}, cacheKey: CacheKey, forceRefresh: boolean = false) {
    if (!!cache[cacheKey] && !forceRefresh) {
        return cache[cacheKey].asObservable();
    } else {
        if (!cache[cacheKey]) {
            cache[cacheKey] = new ReplaySubject<Result>(1);
        }
        call().pipe(take(1)).subscribe(res => cache[cacheKey].next(res), e => cache[cacheKey].error(e));
        return cache[cacheKey].asObservable().pipe(tap(_ => {}, err => {
            delete cache[cacheKey];
        }, () => {
            cache[cacheKey].complete();
            delete cache[cacheKey];
        }));
    }
}
